<template>
  <div>
    <top-navigation class="top-navigation">
      <template slot="middle">
        <h1 class="text-center"><span class="white">ANIMALS <br />{{ factFiles.length }}</span> / {{ factFilesList.length }}</h1>
      </template>
      <div slot="right" class="logo">
        <img src="../../assets/img/ngkids-photo_ark.png"/>
      </div>
    </top-navigation>
    <div class="container-fluid" v-if="factFilesList.length">
      <div class="row fact-cards">
        <div class="col-4 p-0 m-0 fact-card" :key="index" v-for="(factFile, index) in factFilesList">
          <router-link v-if="factFiles.includes(factFile.ID)" :to="{ name: 'FactFile', params: { id: factFile.ID.toString()} }">
            <img class="img-fluid middle fact-file-img" :src="factFile.featuredImage">
            <img class="lock" src="../../assets/img/unlocked.png" />
          </router-link>
          <template v-else>
            <div class="overlay-img-wrapper">
            <div class="overlay-img">
              <img class="lock" src="../../assets/img/locked.png" />
            </div>
            <img class="img-fluid fact-file-img" :src="factFile.featuredImage">
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation'
import { mapGetters } from 'vuex'

export default {
  name: 'FactCards',
  components: {
    TopNavigation
  },
  computed: {
    ...mapGetters(['factFiles', 'factFilesList'])
  }
}
</script>

<style scoped>
  h1 {
    margin-top: 1vh;
    font-family: "Geograph-Bold";
    color: #ffbf00;
    font-size: 6vh;
  }

  h3 {
    color: #fff;
    font-family: "Geograph-Black";
  }

  .empty {
    width: 100%;
    height: 100%;
    border: 10px solid #feca2f;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
  }

  .fact-cards img {
    position: absolute;
    z-index: 88;
  }

  .overlay-img {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.6);
    position: absolute;
    z-index: 99;
  }

  .fact-card {
    overflow: hidden;
    height: 40vh;
  }

  .overlay-img .fa-lock {
    font-size: 3vh;
    margin-left: 1vw;
    margin-top: 1vw;
    color: #ffbf00;
    position: absolute;
  }

  .lock {
    margin-left: 1vw;
  }

  .fact-file-img {
    transform: scale(0.6);
  }
</style>
